import React, { createContext, useState } from "react";
import styled from "styled-components";

import { CloseCircleIcon } from "assets/icons";
import { ReloadingView } from "ui/components/ReloadingView";
import { Modal, StyledModal } from "ui/components/styled";

const ErrorModal = styled(Modal)`
  &_content-wrapper ${StyledModal.Content} {
    text-align: center;
  }
`;

const ErrorIcon = styled(CloseCircleIcon)`
  color: red;
  width: 62px;
  height: auto;
  margin: 0 auto;
  display: block;
`;

interface ViewElementsContextValue {
  modal: {
    isOpen: boolean;
    open: (error: string) => void;
    close: () => void;
  };
  loader: {
    open: () => void;
    close: () => void;
  };
}

export const FixedElementsContext = createContext<ViewElementsContextValue | undefined>(undefined);

interface ViewElementsContextProps {
  children: React.ReactNode;
}
export const FixedElementsContextProvider = (props: ViewElementsContextProps) => {
  const { children } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isLoadingOpen, setLoadingOpen] = useState(false);

  const openModal = (error: string) => {
    setModalOpen(true);
    setErrorMessage(error);
  };

  const closeModal = () => {
    setModalOpen(false);
    setErrorMessage(null);
  };

  const openLoading = () => {
    setLoadingOpen(true);
  };

  const closeLoading = () => {
    setLoadingOpen(false);
  };

  return (
    <FixedElementsContext.Provider
      value={{
        modal: { isOpen: isModalOpen, open: openModal, close: closeModal },
        loader: { open: openLoading, close: closeLoading },
      }}
    >
      {children}
      <ErrorModal label="Error!" isOpen={isModalOpen} onRequestClose={closeModal}>
        <StyledModal.Header>
          <ErrorIcon />
          <StyledModal.Title>Error!</StyledModal.Title>
        </StyledModal.Header>
        <StyledModal.Content>{errorMessage}</StyledModal.Content>
        <StyledModal.Footer>
          <StyledModal.ConfirmDangerButton onClick={closeModal}>OK</StyledModal.ConfirmDangerButton>
        </StyledModal.Footer>
      </ErrorModal>
      {isLoadingOpen && <ReloadingView type="LOADING" />}
    </FixedElementsContext.Provider>
  );
};
